import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-66da9347"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "value-props",
  "aria-labelledby": "value-props-title"
}
const _hoisted_2 = {
  class: "value-props__inner",
  dir: "auto"
}
const _hoisted_3 = { class: "value-props__eyebrow" }
const _hoisted_4 = { id: "value-props-title" }
const _hoisted_5 = { class: "value-props__grid" }
const _hoisted_6 = {
  class: "value-card__icon",
  "aria-hidden": "true"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ic = _resolveComponent("ic")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("p", _hoisted_3, _toDisplayString(_ctx.$t('home.valueProps.eyebrow')), 1),
      _createElementVNode("h2", _hoisted_4, _toDisplayString(_ctx.$t('home.valueProps.title')), 1),
      _createElementVNode("div", _hoisted_5, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.items, (item) => {
          return (_openBlock(), _createElementBlock("article", {
            key: item.key,
            class: "value-card"
          }, [
            _createElementVNode("span", _hoisted_6, [
              _createVNode(_component_ic, {
                icon: ['fas', item.icon]
              }, null, 8, ["icon"])
            ]),
            _createElementVNode("div", null, [
              _createElementVNode("h3", null, _toDisplayString(_ctx.$t(`home.valueProps.items.${item.key}.title`)), 1),
              _createElementVNode("p", null, _toDisplayString(_ctx.$t(`home.valueProps.items.${item.key}.desc`)), 1)
            ])
          ]))
        }), 128))
      ])
    ])
  ]))
}